module.exports = __webpack_public_path__ + "images/linear-regression-06.webp";